export default "__VITE_ASSET__Cs0w_n60__"